module.exports = __webpack_public_path__ + "img/poorter_hotel-044.71681d57.jpg";